<template>
  <PopupModal :open="open" has-close-button @close="close">
    <template #body>
      <div>
        <div>
          <AssistantSmiling class="mx-auto mb-8" />
        </div>
        <div>
          {{ t("favorite.articles.screen.remove.confirmation.message") }}
        </div>
      </div>
    </template>
    <template #footer>
      <div class="flex flex-row w-full justify-center gap-4">
        <div class="text-center">
          <ButtonElement
            :label="t('no')"
            :disabled-visible="true"
            @click="close"
          />
        </div>
        <div class="text-center">
          <ButtonElement :label="t('yes')" @click="remove" />
        </div>
      </div>
    </template>
  </PopupModal>
</template>
<script setup lang="ts">
import PopupModal from "../layout/PopupModal.vue";
import ButtonElement from "../form/ButtonElement.vue";
import AssistantSmiling from "../icon/AssistantSmiling.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const emit = defineEmits(["close", "removeFavorite"]);

const props = defineProps({
  open: {
    type: Boolean,
    required: true,
  },
  teamId: {
    type: Number,
  },
  challengeId: {
    type: String,
  },
});

async function remove() {
  emit("removeFavorite");
}

function close() {
  emit("close");
}
</script>
